// reducer.js

import {
  FETCH_CANDIDATE_REQUEST,
  FETCH_CANDIDATE_SUCCESS,
  FETCH_CANDIDATE_FAILURE,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  data: [],
  message: "",
  status:false
};

const candidateSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CANDIDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_CANDIDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        status:action.payload.status
      };
    case FETCH_CANDIDATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        status:action.payload.status,
        message:action.payload.message
      };
    default:
      return state;
  }
};

export default candidateSearchReducer;
